
export default {
    name: 'anamnese-historique',
    components: {},
    props: ["consultation", "activeRole", "is_printable"],
    data() {
        return {
            is_loading: true,
            histo_is_empty: false,
        }
    },
    computed: {
        histoire_anamnese_historique() {
            return this.$store.getters["histoire_anamnese_historique"];
        },
    },
    mounted() { 
        this.historiqueAnamnese()
    },
    methods: {
        async historiqueAnamnese() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'histoire_de_la_maladie',
                est_en_cours: false
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                if (this.histoire_anamnese_historique.length == 0) {
                    this.histo_is_empty = true
                } else {
                    this.histo_is_empty = false
                }
                this.is_loading = false
            })
        },
    }
}


